import PropTypes from 'prop-types';
import React from 'react';

import { FormSectionCollapsible, Separator } from 'twyne-new.ui';

import AuditResultBody from './AuditResultBody';
import AuditResultTable from './AuditResultTable';

const AuditResult = ({ id, impressions }) => <>
  <FormSectionCollapsible
    defaultOpen
    border
    triggerClass='py-2 px-4 twy-subtle-neutral'
    contentClass='p-4'
    titleClass='text-base pr-2'
    title={<Header id={id} impressions={impressions} />}
  >
    <AuditResultBody impression={impressions[0]} />
    <Separator className='my-4' />
    <span className='text-md mb-2'>Requests</span>
    <AuditResultTable impressions={impressions} />
  </FormSectionCollapsible>
</>

const Header = ({ id, impressions }) => <div>
  <span className='text-md'>{`${impressions[0].user.first_name} ${impressions[0].user.last_name}`}</span>
  <span className='mx-1'>-</span>
  <span className='text-sm twy-text-base'>{`There are ${impressions.length} impressions on session ${id}`}</span>
</div>

AuditResult.propTypes = {
  id: PropTypes.any,
  impressions: PropTypes.array,
};

export default AuditResult;
